// Einbürgerungs-Selbsttest data and evaluation logic
// Source: Kanzlei-eigener Selbsttest, Stand StAG-Reform 30.10.2025

export const selbsttestQuestions = [
  {
    id: 'q1_dauer',
    title: 'Wie lange leben Sie schon in Deutschland?',
    help: 'Gemeint ist Ihr ununterbrochener rechtmäßiger Aufenthalt. Wenn Ihr Asylverfahren positiv abgeschlossen wurde, zählt die Verfahrensdauer mit.',
    options: [
      { v: 'u3', l: 'Weniger als 3 Jahre' },
      { v: 'd3_5', l: '3 bis unter 5 Jahre' },
      { v: 'd5_8', l: '5 bis unter 8 Jahre' },
      { v: 'u8', l: '8 Jahre oder länger' },
    ],
  },
  {
    id: 'q2_titel',
    title: 'Welchen Aufenthaltstitel haben Sie?',
    help: 'Sehen Sie in Ihrem elektronischen Aufenthaltstitel oder in Ihrem Reisepass nach. Wählen Sie die Variante, die am ehesten passt.',
    options: [
      { v: 'nle', l: 'Niederlassungserlaubnis oder Daueraufenthalt-EU (unbefristet)' },
      { v: 'ae_ok', l: 'Befristete Aufenthaltserlaubnis als Flüchtling, Familienangehöriger oder Fachkraft' },
      { v: 'ae_sper', l: 'Aufenthaltserlaubnis aus humanitären Gründen (§§ 25 Abs. 3-5, 22, 23a, 104c AufenthG) oder zum Studium / zur Ausbildung' },
      { v: 'freizug', l: 'Ich bin EU-Bürger / habe ein Freizügigkeitsrecht' },
    ],
  },
  {
    id: 'q3_ehe',
    title: 'Sind Sie mit einer/einem deutschen Staatsangehörigen verheiratet?',
    help: 'Bei deutschen Ehepartnern gelten kürzere Wartezeiten (§ 9 StAG).',
    options: [
      { v: 'ja_2j', l: 'Ja, seit mindestens 2 Jahren' },
      { v: 'ja_u2j', l: 'Ja, seit weniger als 2 Jahren' },
      { v: 'nein', l: 'Nein' },
    ],
  },
  {
    id: 'q4_unterhalt',
    title: 'Können Sie für sich und Ihre Familie selbst sorgen?',
    help: 'Es geht darum, ob Sie aktuell Bürgergeld (Jobcenter / SGB II) oder Sozialhilfe (Sozialamt / SGB XII) beziehen. Arbeitslosengeld I ist unschädlich.',
    options: [
      { v: 'ja', l: 'Ja, ich komme ohne Bürgergeld oder Sozialhilfe aus' },
      { v: 'teil', l: 'Ich bekomme aktuell teilweise Bürgergeld oder Sozialhilfe' },
      { v: 'voll', l: 'Ich bin auf Bürgergeld oder Sozialhilfe angewiesen' },
    ],
  },
  {
    id: 'q5_vollzeit',
    title: 'Waren Sie in den letzten 2 Jahren in Vollzeit beschäftigt?',
    help: 'Wenn Sie in den vergangenen 24 Monaten mindestens 20 Monate in Vollzeit gearbeitet haben, gilt eine Sonderregel.',
    options: [
      { v: 'ja', l: 'Ja, ich war mindestens 20 von 24 Monaten in Vollzeit beschäftigt' },
      { v: 'familie', l: 'Mein Ehepartner erfüllt das, und wir haben ein gemeinsames minderjähriges Kind' },
      { v: 'nein', l: 'Nein' },
    ],
  },
  {
    id: 'q6_sprache',
    title: 'Welchen Deutsch-Nachweis haben Sie?',
    help: 'Erforderlich ist mindestens das Niveau B1 (Gemeinsamer Europäischer Referenzrahmen).',
    options: [
      { v: 'b1', l: 'Ein Zertifikat B1 oder höher (z. B. DTZ, telc, Goethe-Zertifikat, ÖSD)' },
      { v: 'abschluss', l: 'Einen deutschen Schul-, Berufs- oder Hochschulabschluss' },
      { v: 'haerte', l: 'Keinen Nachweis – wegen Krankheit, Behinderung oder hohen Alters fällt mir das Lernen schwer' },
      { v: 'kein', l: 'Keinen Nachweis' },
    ],
  },
  {
    id: 'q7_test',
    title: 'Haben Sie den Einbürgerungstest bestanden?',
    help: 'Der Test „Leben in Deutschland" wird beim BAMF oder bei der Volkshochschule abgelegt.',
    options: [
      { v: 'ja', l: 'Ja, ich habe den Test bestanden' },
      { v: 'entfaellt', l: 'Ich habe einen deutschen Schulabschluss – der Test entfällt' },
      { v: 'nein', l: 'Nein, noch nicht' },
    ],
  },
  {
    id: 'q8_id',
    title: 'Können Sie Ihre Identität nachweisen?',
    help: 'Dazu gehören ein gültiger Reisepass, eine Geburtsurkunde sowie ggf. weitere Urkunden mit Apostille oder Legalisation.',
    options: [
      { v: 'ja', l: 'Ja, ich habe alle erforderlichen Urkunden' },
      { v: 'teil', l: 'Teilweise – die Beschaffung von Urkunden aus meinem Heimatland ist mir nicht zumutbar' },
      { v: 'nein', l: 'Nein, ich habe derzeit keine ausreichenden Nachweise' },
    ],
  },
  {
    id: 'q9_strafe',
    title: 'Sind Sie strafrechtlich verurteilt worden?',
    help: 'Geringfügige Verurteilungen sind unschädlich; bestimmte Schwellen führen jedoch zur Ablehnung.',
    options: [
      { v: 'keine', l: 'Nein, ich habe keine Verurteilungen und es läuft kein Verfahren' },
      { v: 'gering', l: 'Eine Geldstrafe bis 90 Tagessätze oder eine jugendrechtliche Erziehungsmaßregel' },
      { v: 'mittel', l: 'Eine Geldstrafe über 90 Tagessätze oder Freiheitsstrafe unter 3 Monaten auf Bewährung' },
      { v: 'schwer', l: 'Eine höhere Verurteilung oder eine antisemitische, rassistische oder menschenverachtende Tat' },
      { v: 'laufend', l: 'Gegen mich läuft aktuell ein Strafverfahren' },
    ],
  },
  {
    id: 'q10_loyal',
    title: 'Können Sie sich zur freiheitlich demokratischen Grundordnung bekennen?',
    help: 'Sie müssen sich zudem zur besonderen historischen Verantwortung Deutschlands bekennen, insbesondere zum Schutz jüdischen Lebens und gegen jede Form des Antisemitismus.',
    options: [
      { v: 'ja', l: 'Ja, uneingeschränkt' },
      { v: 'zweifel', l: 'Im Grundsatz ja – es gibt aber frühere Äußerungen, die problematisch sein könnten' },
      { v: 'nein', l: 'Nein' },
    ],
  },
  {
    id: 'q11_extrem',
    title: 'Sind Sie Mitglied einer extremistischen Vereinigung?',
    help: 'Gemeint sind verfassungsfeindliche, antisemitische, rassistische, gewaltbereite oder sonstige menschenverachtende Gruppen oder Bestrebungen.',
    options: [
      { v: 'nein', l: 'Nein' },
      { v: 'fraglich', l: 'Mir ist nicht bekannt, ob frühere Aktivitäten so eingestuft werden könnten' },
      { v: 'ja', l: 'Ja' },
    ],
  },
];

// Evaluation logic — 1:1 adaptiert aus dem Original (Kanzlei-Selbsttest)
export function evaluateSelbsttest(a) {
  const hits = [];
  const blockers = [];
  const actions = [];
  let status = 'green';
  let statusIcon = '✓';
  let basis = 'Anspruch nach § 10 StAG';
  let title = 'Sie erfüllen die Voraussetzungen voraussichtlich';
  let subtitle = 'Nach Ihren Angaben sind die wesentlichen Voraussetzungen erfüllt.';

  // Zwingende Ausschlussgründe
  if (a.q11_extrem === 'ja') {
    return {
      status: 'red',
      statusIcon: '✕',
      title: 'Eine Einbürgerung ist derzeit nicht möglich',
      subtitle: 'Gesetzlicher Ausschlussgrund',
      basis: '§ 11 StAG (zwingender Ausschlussgrund)',
      hits: [],
      blockers: [
        'Mitgliedschaften oder Tätigkeiten in extremistischen Vereinigungen schließen eine Einbürgerung zwingend aus – unabhängig davon, wie lange Sie schon in Deutschland leben oder wie gut Sie integriert sind.',
      ],
      actions: [
        'Lassen Sie sich in einem vertraulichen Gespräch beraten, bevor Sie einen Antrag stellen.',
        'Eine spätere Einbürgerung kann möglich werden, wenn Sie sich nachweislich und glaubhaft von solchen Bestrebungen lösen.',
      ],
    };
  }
  if (a.q9_strafe === 'schwer') {
    return {
      status: 'red',
      statusIcon: '✕',
      title: 'Eine Einbürgerung ist aktuell nicht möglich',
      subtitle: 'Ausschluss wegen Vorstrafen',
      basis: '§ 12a StAG (strafrechtlicher Ausschlussgrund)',
      hits: [],
      blockers: [
        'Verurteilungen oberhalb bestimmter Schwellen oder Taten mit rassistischem, antisemitischem oder menschenverachtendem Hintergrund stehen einer Einbürgerung entgegen.',
      ],
      actions: [
        'Wir prüfen für Sie, wann die Eintragung im Bundeszentralregister getilgt wird.',
        'Prüfung, ob ein Wiederaufnahme- oder Gnadenverfahren in Betracht kommt.',
      ],
    };
  }

  // Aufenthaltstitel
  if (a.q2_titel === 'ae_sper') {
    blockers.push('Mit Ihrem aktuellen Aufenthaltstitel ist eine direkte Einbürgerung nicht möglich. Sie müssten zunächst eine Niederlassungserlaubnis bekommen.');
    status = 'red';
    statusIcon = '✕';
    title = 'Aktuell noch nicht möglich';
    subtitle = 'Ihr Aufenthaltstitel reicht noch nicht aus.';
    basis = '§ 10 Abs. 1 Nr. 2 StAG';
    actions.push('Wir prüfen für Sie, ob Sie eine Niederlassungserlaubnis nach § 26 IV oder § 9 AufenthG bekommen können.');
    actions.push('Sobald Sie diese haben, können wir die Einbürgerung prüfen.');
  } else {
    hits.push('Ihr Aufenthaltstitel ist für eine Einbürgerung geeignet.');
  }

  // Aufenthaltsdauer
  const eheKurz = a.q3_ehe === 'ja_2j';
  if (a.q1_dauer === 'u8' || a.q1_dauer === 'd5_8') {
    hits.push('Sie leben lange genug in Deutschland (mindestens 5 Jahre).');
  } else if (a.q1_dauer === 'd3_5' && eheKurz) {
    hits.push('Sie leben mindestens 3 Jahre in Deutschland und sind seit über 2 Jahren mit einem deutschen Ehepartner verheiratet (§ 9 StAG).');
    basis = '§ 9 StAG (Ehegatteneinbürgerung)';
  } else if (a.q1_dauer === 'd3_5') {
    blockers.push('Sie haben die 5-Jahres-Frist noch nicht erreicht. Die frühere Möglichkeit, sich bereits nach 3 Jahren einbürgern zu lassen, wurde am 30.10.2025 abgeschafft.');
    if (status === 'green') {
      status = 'amber';
      statusIcon = '!';
    }
    title = 'Noch etwas Geduld';
    subtitle = 'Sie müssen die 5-Jahres-Frist noch erreichen.';
    actions.push('Nutzen Sie die Wartezeit, um Ihre Unterlagen vorzubereiten (Sprachtest, Einbürgerungstest, Personenstandsurkunden).');
  } else if (a.q1_dauer === 'u3') {
    blockers.push('Sie leben noch nicht lange genug in Deutschland.');
    status = 'red';
    statusIcon = '✕';
    title = 'Sie müssen noch warten';
    subtitle = 'Die erforderliche Mindestaufenthaltsdauer ist nicht erreicht.';
    actions.push('Frühestens nach 5 Jahren können Sie einen Antrag stellen – bei deutschem Ehepartner nach 3 Jahren.');
  }

  // Lebensunterhalt
  if (a.q4_unterhalt === 'ja') {
    hits.push('Sie können Ihren Lebensunterhalt selbst sichern.');
  } else if (a.q5_vollzeit === 'ja' || a.q5_vollzeit === 'familie') {
    hits.push('Ihre Vollzeitbeschäftigung in den letzten 24 Monaten gilt als Ausnahme (§ 10 Abs. 1 Nr. 3b/c StAG).');
  } else {
    blockers.push('Der Bezug von Bürgergeld oder Sozialhilfe steht einer Einbürgerung grundsätzlich entgegen, wenn er von Ihnen zu vertreten ist.');
    if (status === 'green') {
      status = 'amber';
      statusIcon = '!';
      title = 'Härtefall prüfen';
      subtitle = 'Wir müssen begründen, warum Sie keine Arbeit aufnehmen können.';
    }
    actions.push('Wir prüfen für Sie eine Härtefallregelung nach § 8 Abs. 2 StAG – etwa wegen Krankheit, Behinderung, Studium oder weil Sie alleinerziehend sind.');
    actions.push('Halten Sie entsprechende Nachweise bereit (ärztliche Atteste, Pflegestufe, Immatrikulationsbescheinigung).');
    basis = '§ 8 Abs. 2 StAG (Ermessenseinbürgerung im Härtefall)';
  }

  // Sprache
  if (a.q6_sprache === 'b1' || a.q6_sprache === 'abschluss') {
    hits.push('Ihre Deutschkenntnisse sind ausreichend nachgewiesen.');
  } else if (a.q6_sprache === 'haerte') {
    hits.push('Sie können eine Ausnahme von der Sprachprüfung in Anspruch nehmen (§ 10 Abs. 6 StAG).');
    actions.push('Bringen Sie ein ärztliches Attest zur Beratung mit.');
  } else {
    blockers.push('Sie benötigen noch einen Nachweis über Deutschkenntnisse auf Niveau B1.');
    if (status === 'green') {
      status = 'amber';
      statusIcon = '!';
      title = 'Noch Unterlagen erforderlich';
    }
    actions.push('Melden Sie sich zu einer B1-Prüfung an (z. B. DTZ bei der VHS, telc oder Goethe-Institut).');
  }

  // Einbürgerungstest
  if (a.q7_test === 'ja' || a.q7_test === 'entfaellt') {
    hits.push('Ihre staatsbürgerlichen Kenntnisse sind nachgewiesen.');
  } else {
    blockers.push('Sie haben den Einbürgerungstest noch nicht bestanden.');
    if (status === 'green') {
      status = 'amber';
      statusIcon = '!';
      title = 'Noch Unterlagen erforderlich';
    }
    actions.push('Melden Sie sich zum Test „Leben in Deutschland" beim BAMF oder bei einer Volkshochschule an. Vorbereitungsmaterial gibt es online kostenlos.');
  }

  // Identität
  if (a.q8_id === 'ja') {
    hits.push('Ihre Identität ist geklärt.');
  } else if (a.q8_id === 'teil') {
    blockers.push('Ihre Urkunden sind unvollständig. Wir müssen darlegen, warum die Beschaffung aus dem Heimatland unzumutbar ist (§ 12 Abs. 1 S. 2 Nr. 5 StAG).');
    actions.push('Bringen Sie zur Beratung alle vorhandenen Dokumente mit (Schulzeugnisse, Familienfotos, alte Reisedokumente).');
    actions.push('Wir bereiten für Sie eine eidesstattliche Versicherung und eine ausführliche Begründung vor.');
  } else {
    blockers.push('Ohne Klärung Ihrer Identität ist eine Einbürgerung nicht möglich.');
    if (status === 'green') {
      status = 'amber';
      statusIcon = '!';
      title = 'Identität zuerst klären';
    }
    actions.push('Wir helfen Ihnen, fehlende Urkunden zu beschaffen – ggf. über einen Vertrauensanwalt im Heimatland.');
  }

  // Strafrecht
  if (a.q9_strafe === 'keine') {
    hits.push('Sie sind unbestraft – keine strafrechtlichen Hürden.');
  } else if (a.q9_strafe === 'gering') {
    hits.push('Ihre geringfügige Verurteilung steht der Einbürgerung nicht entgegen.');
  } else if (a.q9_strafe === 'mittel') {
    blockers.push('Ihre Verurteilung liegt oberhalb der Bagatellgrenze. Wir müssen den Einzelfall prüfen.');
    if (status === 'green') {
      status = 'amber';
      statusIcon = '!';
      title = 'Strafrechtliche Prüfung nötig';
    }
    actions.push('Wir holen für Sie einen aktuellen Auszug aus dem Bundeszentralregister ein und prüfen Tilgungsfristen.');
  } else if (a.q9_strafe === 'laufend') {
    blockers.push('Solange Ihr Strafverfahren läuft, wird das Einbürgerungsverfahren in der Regel ausgesetzt (§ 12a Abs. 3 StAG).');
    if (status === 'green') {
      status = 'amber';
      statusIcon = '!';
      title = 'Erst Strafverfahren abwarten';
    }
    actions.push('Wir empfehlen, den Ausgang des Strafverfahrens abzuwarten, bevor Sie den Einbürgerungsantrag stellen.');
  }

  // Loyalität
  if (a.q10_loyal === 'ja') {
    hits.push('Sie können das Bekenntnis zur freiheitlichen demokratischen Grundordnung abgeben.');
  } else if (a.q10_loyal === 'zweifel') {
    blockers.push('Frühere Äußerungen könnten die Behörde an Ihrem Bekenntnis zweifeln lassen. Wir sollten vor Antragstellung eine Stellungnahme vorbereiten.');
    if (status === 'green') {
      status = 'amber';
      statusIcon = '!';
      title = 'Bekenntnis vorbereiten';
    }
    actions.push('Bringen Sie Beispiele Ihrer öffentlichen Äußerungen (z. B. Social Media) zur Beratung mit.');
    actions.push('Achtung: Falsche Angaben können zu einer 10-Jahres-Sperrfrist führen (§ 35a StAG).');
  } else if (a.q10_loyal === 'nein') {
    blockers.push('Ohne dieses Bekenntnis ist eine Einbürgerung nicht möglich.');
    status = 'red';
    statusIcon = '✕';
    title = 'Einbürgerung nicht möglich';
    subtitle = 'Das gesetzlich verlangte Bekenntnis muss abgegeben werden können.';
  }

  // Extremismus fraglich
  if (a.q11_extrem === 'fraglich') {
    blockers.push('Die Behörde wird beim Verfassungsschutz nachfragen. Diese Auskunft müssen wir abwarten.');
    if (status === 'green') {
      status = 'amber';
      statusIcon = '!';
      title = 'Sicherheitsabfrage abwarten';
    }
  }

  return { status, statusIcon, title, subtitle, basis, hits, blockers, actions };
}
